<template>
    <div class="echarts-contain">
        <div :id="id" class="o-echarts"></div>
    </div>
</template>

<script>
    import echarts from 'echarts';

    export default {
        name: 'radarCharts',
        props: {
            'radarData': Array
        },
        data () {
            return {
                id: 'echarts_' + new Date().getTime() + Math.floor(Math.random() * 1000),
                echartObj: null,
                option: {
                    tooltip: {
                        show: false
                    },
                    radar: {},
                    series: {},
                }
            };
        },
        mounted () {
            this.echartObj = echarts.init(document.getElementById(this.id));
            this.echartObj.setOption(this.setSeriesData(), true);
        },
        computed: {
        },
        watch: {
            radarData: {
                handler (newValue, oldValue) {
                    for (let i = 0; i < newValue.length; i++) {
                        if (oldValue[i] !== newValue[i]) {
                            this.echartObj.setOption(this.setSeriesData(), true);
                        }
                    }
                },
                deep: true
            }
        },
        methods: {
            getXaxisData () {
                // 填入value
                if (this.radarData.length > 0) {
                    return this.radarData.map(item => {
                        return item.value
                    });
                }
            },
            getSeriesData () {
                // 填入数据
                return this.radarData
            },
            setSeriesData () {
                var arr1 = this.getXaxisData();
                var i = -1;
                this.setOptions('grid',(()=>{
                   return{
                       position: 'center',
                   }
                })());
                this.setOptions('radar', (() => {
                    return {
                        name: {
                            rich: { //设置取值label颜色样式
                                a: {
                                    color: '#666'
                                },
                                b: {
                                    color: '#36B374',
                                    align: 'center',
                                    backgroundColor: 'rgba(255,255,255,0)',
                                    padding: 4
                                } 
                            },
                            formatter: (a, b) => {
                                i++;
                                if(i===0|i===1|i===(arr1.length-1)){
                                    return `{b|${arr1[i]}}\n{a|${a}}`
                                }else{
                                    return `{a|${a}}\n{b|${arr1[i]}}`
                                }
                                
                            }
                        },
                        indicator: this.getSeriesData(),
                        splitLine: { 
                            show: true,
                            lineStyle: {//设置线圈的颜色和宽度
                                color:"#CCCCCC",
                                width: 0.5,
                            }
                        },
                        // 设置雷达图中间射线的颜色
                        axisLine: {
                            lineStyle: {
                                color: '#CCCCCC',
                                width:0.5
                            },
                        },
                        splitArea: {
                            show: true,
                            areaStyle: {
                                color: '#fff'
                            }
                        },
                        splitNumber: 2, // 雷达图圈数设置
                        radius: 65 //设置图列的大小
                    }
                })());
                this.setOptions('series', (() => {
                    return {
                        name: '指数',
                        type: 'radar',
                        label: {
                            show: false
                        },
                        areaStyle: {
                            normal: {
                                color: '#86D1AC' // 选中区域颜色
                            }
                        },
                        lineStyle: {
                            normal: { //设置选中区域的线条颜色
                                color: '#36B374', // 线条颜色
                                width:1
                            }
                        },
                        itemStyle: {
                            normal: {
                                color: '#36B374', // 线条颜色
                                opacity: 0
                            }
                        },
                        data: [
                            {
                                value: this.getXaxisData(),
                                name: '指数'
                            }
                        ]
                    }
                })());
                return this.option;
            },
            setOptions (objKey, objVal) {
                if (this.option[objKey] && typeof this.option[objKey] === 'object' && !Array.isArray(this.option[objKey])) {
                    this.option[objKey] = Object.assign(this.option[objKey], objVal);
                } else {
                    this.option[objKey] = objVal;
                }
                this.$set(this.option, objKey, this.option[objKey]);
            }
        }
    }
</script>

<style lang="less" scoped>
.echarts-contain{
    width: 100%;
    height: 100%;
    .o-echarts {
        width: 100%;
        height: 100%;
    }
}
</style>
